import { FileData } from "@/utils/types";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useFilePathToFileTreeLookup = () => {
  const fileTree = useSelector((state: any) => state.codebase.fileTree);

  return useMemo(() => {
    let filePathToFileTreeLookup = {};

    const traverseTree = (file: FileData) => {
      if (file.type === "file") {
        filePathToFileTreeLookup[file.fullPath] = file;
      } else {
        // @ts-expect-error TS18048
        file.items.forEach((child) => {
          traverseTree(child);
        });
      }
    };

    if (fileTree) {
      fileTree.forEach((file) => {
        traverseTree(file);
      });
    }

    return filePathToFileTreeLookup;
  }, [fileTree]);
};
